var _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgEyebrow = function SvgEyebrow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12 7c-4.863 0-7.581 3.873-8.568 5.64-.21.375-.314.562-.302.844.011.283.135.466.381.833C4.685 16.063 7.798 20 12 20s7.315-3.937 8.488-5.683c.247-.367.37-.55.382-.833s-.093-.47-.302-.844C19.581 10.873 16.863 7 12 7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M21 7s-3.6-4-9-4-9 4-9 4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 13.5,
    stroke: "currentColor",
    rx: 3,
    ry: 2.5
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEyebrow);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;